(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3410],{

/***/ 824394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "invariant": function() { return /* binding */ invariant; },
/* harmony export */   "warning": function() { return /* binding */ warning; }
/* harmony export */ });
var warning = function () { };
var invariant = function () { };
if (false) {}




/***/ }),

/***/ 273467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CloseIconGrey; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

function CloseIconGrey() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.8346 1.34102L10.6596 0.166016L6.0013 4.82435L1.34297 0.166016L0.167969 1.34102L4.8263 5.99935L0.167969 10.6577L1.34297 11.8327L6.0013 7.17435L10.6596 11.8327L11.8346 10.6577L7.1763 5.99935L11.8346 1.34102Z",
            fill: "#B9B9B9"
        })
    });
}


/***/ }),

/***/ 350541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ DropDownArrowSort; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var DropDownArrowSort = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "8",
        viewBox: "0 0 12 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.59 7.41016L6 2.83016L1.41 7.41016L0 6.00016L6 0.000156403L12 6.00016L10.59 7.41016Z",
            fill: "black"
        })
    });
};


/***/ }),

/***/ 472933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ MobileFilterIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

function MobileFilterIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.58098 1.16602H12.4143C12.5343 1.20811 12.6431 1.27711 12.7323 1.36774C12.8216 1.45836 12.8889 1.56821 12.9291 1.68887C12.9693 1.80952 12.9814 1.93778 12.9644 2.06382C12.9474 2.18986 12.9017 2.31033 12.831 2.41602L8.66431 6.99935V12.8327L5.33098 10.3327V6.99935L1.16431 2.41602C1.09356 2.31033 1.04793 2.18986 1.03092 2.06382C1.01392 1.93778 1.02598 1.80952 1.0662 1.68887C1.10642 1.56821 1.17372 1.45836 1.26295 1.36774C1.35218 1.27711 1.46097 1.20811 1.58098 1.16602Z",
            stroke: "black",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 272468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ MobileSortByArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

function MobileSortByArrow() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "9",
        height: "14",
        viewBox: "0 0 9 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 4.49935L4.83333 1.16602L8.16667 4.49935M4.83333 1.16602V12.8327",
            stroke: "black",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 493757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var OfferIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 15 : _height, _width = param.width, width = _width === void 0 ? 15 : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.236 8.62713L9.244 0.635127C9.07948 0.471113 8.88419 0.341193 8.66934 0.252817C8.4545 0.164442 8.22431 0.11935 7.992 0.120127H1.776C1.30538 0.121446 0.854417 0.308984 0.521638 0.641763C0.188859 0.974542 0.00132197 1.42551 2.59218e-06 1.89613V8.11213C-0.000398322 8.34653 0.0457096 8.57867 0.135656 8.79513C0.225602 9.01158 0.357599 9.20804 0.524002 9.37313L8.516 17.3651C8.68053 17.5291 8.87582 17.6591 9.09066 17.7474C9.30551 17.8358 9.53569 17.8809 9.768 17.8801C10.0012 17.8813 10.2322 17.8356 10.4473 17.7456C10.6624 17.6555 10.8572 17.5231 11.02 17.3561L17.236 11.1401C17.403 10.9773 17.5354 10.7826 17.6254 10.5675C17.7155 10.3524 17.7612 10.1213 17.76 9.88813C17.7584 9.41515 17.5701 8.96195 17.236 8.62713ZM9.768 16.1131L1.776 8.11313V1.89613H7.992V1.88713L15.984 9.87913L9.768 16.1131Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.2041 5.32422C4.75639 5.32422 5.2041 4.8765 5.2041 4.32422C5.2041 3.77193 4.75639 3.32422 4.2041 3.32422C3.65182 3.32422 3.2041 3.77193 3.2041 4.32422C3.2041 4.8765 3.65182 5.32422 4.2041 5.32422Z",
                fill: "currentColor"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OfferIcon);


/***/ }),

/***/ 965700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);


var LoaderIcon = function(props) {
    var waterSplashLoader = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "waterSplashLoader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var ellipsis = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "ds-ellipsis-loader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var _renderLoader = function(type) {
        switch(type){
            case "water_splash_loader":
                return waterSplashLoader();
            case "ellipsis":
            default:
                return ellipsis();
        }
    };
    return _renderLoader(props.type || "");
};
/* harmony default export */ __webpack_exports__["Z"] = (LoaderIcon);


/***/ }),

/***/ 192134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OK": function() { return /* binding */ Tab; },
/* harmony export */   "P6": function() { return /* binding */ StripContainer; },
/* harmony export */   "To": function() { return /* binding */ StripIconInfoWrapper; },
/* harmony export */   "YT": function() { return /* binding */ StripOfferIcon; },
/* harmony export */   "iQ": function() { return /* binding */ StripCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(270758);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(313508);
/* harmony import */ var src_assets_svgExports_OfferIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(493757);




var StripOfferIcon = function(param) {
    var _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? null : _iconSize, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var offerIconSize = iconSize || (src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_DESKTOP */ .yn ? 18 : 14);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: customClasses,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_assets_svgExports_OfferIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            height: offerIconSize,
            width: offerIconSize
        })
    });
};
var Tab = function(param) {
    var text = param.text, isActive = param.isActive, onClick = param.onClick, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var themeColor = (0,src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_1__/* .getThemeColor */ .p)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "removeGlobalOverride tw-m-0 tw-cursor-pointer tw-border-x-0 tw-border-b-[3px] tw-border-t-0 tw-border-solid tw-bg-transparent tw-px-[12px] tw-pb-[9px] tw-text-[13px]/[20px] ".concat(isActive ? "tw-font-semibold" : "tw-font-medium", " tw-transition-colors tw-duration-500 md:tw-pb-[13px] md:tw-text-[14px]/[20px] ").concat(customClasses),
        onClick: onClick,
        style: {
            borderColor: isActive ? themeColor : "#ffffff",
            color: isActive ? themeColor : "#000000"
        },
        children: text
    });
};
var StripIconInfoWrapper = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-gap-[8px] ".concat(props.customClasses || ""),
        children: props.children
    });
};
var StripContainer = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-flex-col tw-items-start tw-gap-[8px] tw-border-b tw-border-dashed tw-border-[#EAEAEA]  ".concat(props.showHoverEffect ? "hover:tw-bg-[#F5F5F5]" : "", " md:tw-flex-row md:tw-justify-between md:tw-border-none ").concat(props.customClasses || ""),
        style: {
            backgroundColor: props.bgColor
        },
        onClick: props.onClick,
        children: props.children
    });
};
var StripCTA = function(param) {
    var _ctaTextOrIcon = param.ctaTextOrIcon, ctaTextOrIcon = _ctaTextOrIcon === void 0 ? "Details" : _ctaTextOrIcon, onClick = param.onClick, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled;
    var themeColor = (0,src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_1__/* .getThemeColor */ .p)();
    var handleCTAClick = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        onClick();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "tw-ml-[20px] tw-w-fit ".concat(isDisabled ? "tw-cursor-not-allowed" : "tw-cursor-pointer", " tw-border-none tw-bg-transparent tw-p-0 tw-text-[14px]/[20px] tw-font-semibold md:tw-ml-0 md:tw-text-[16px]/[20px] ").concat(isDisabled ? "tw-opacity-40" : "", " ").concat(customClasses),
        style: {
            color: themeColor
        },
        onClick: handleCTAClick,
        disabled: isDisabled,
        children: ctaTextOrIcon
    });
};


/***/ }),

/***/ 698521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CouponsAndVouchers_PromoSlider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/BasicSlider/index.tsx + 2 modules
var BasicSlider = __webpack_require__(9997);
// EXTERNAL MODULE: ./src/assets/svgExports/OfferIcon.js
var OfferIcon = __webpack_require__(493757);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/index.tsx
var Common = __webpack_require__(192134);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(168615);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromoSlide/index.tsx






var PromoSlide = function(param) {
    var promoData = param.promoData;
    var openProductDetailsModal = function openProductDetailsModal() {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoData === null || promoData === void 0 ? void 0 : promoData.id
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var offerIconSize = checkClientDeviceType/* IS_DESKTOP */.yn ? 15 : 12;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "!tw-flex tw-items-start tw-justify-between tw-border tw-border-solid tw-border-[#E3E3E3] tw-px-[16px] tw-py-[12px] md:tw-items-center md:tw-px-[24px] md:tw-py-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-[12px]/[20px] md:tw-text-[15px]/[20px]",
                        children: "Special Offer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-m-0 tw-flex tw-gap-[4px] md:tw-gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-mt-[4px] tw-flex md:tw-mt-[2.5px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferIcon/* default */.Z, {
                                    height: offerIconSize,
                                    width: offerIconSize
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-m-0 tw-text-[12px]/[20px] tw-font-semibold md:tw-text-[16px]/[20px]",
                                        children: promoData === null || promoData === void 0 ? void 0 : promoData.description
                                    }),
                                    !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "tw-m-0 tw-text-[11px]/[20px] tw-text-[#575757]",
                                        children: [
                                            "Use Code - ",
                                            promoData === null || promoData === void 0 ? void 0 : promoData.code
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-[24px]",
                children: [
                    checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-border tw-border-dashed tw-px-[12px] tw-py-[8px] tw-text-[14px]/[20px] tw-font-semibold",
                        children: [
                            "Use Code - ",
                            promoData === null || promoData === void 0 ? void 0 : promoData.code
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripCTA */.iQ, {
                        onClick: openProductDetailsModal
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CouponsAndVouchers_PromoSlide = (PromoSlide);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromoSlider/index.tsx








var PromoSlider = function(param) {
    var type = param.type, typeId = param.typeId, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _setPromosDataToParent = param.setPromosDataToParent, setPromosDataToParent = _setPromosDataToParent === void 0 ? null : _setPromosDataToParent;
    var getSliderPromos = function getSliderPromos() {
        typeId = Number(typeId);
        if (isNaN(typeId) || typeId < 0) {
            return;
        }
        var data = {
            type: type,
            type_ids: [
                typeId
            ],
            store_id: storeId,
            user_id: userId
        };
        dispatch((0,promo/* getPromosByTypeAndTypeId */.Lr)(data, function(data) {
            setPromosDataToParent(data);
            setPromosData(data);
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)([]), promosData = ref[0], setPromosData = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            storeId: state.storeReducer.store.store_id,
            userId: ((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.user_id) || 0
        };
    }), storeId = ref1.storeId, userId = ref1.userId;
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    (0,react.useEffect)(function() {
        if (type && typeId >= 0 && !isCouponsFeatureLocked) {
            getSliderPromos();
        }
    }, []);
    return !!(promosData === null || promosData === void 0 ? void 0 : promosData.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full ".concat(checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-mb-[24px]" : "tw-mb-[36px]", " ").concat(customClasses),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicSlider/* default */.Z, {
            showArrows: checkClientDeviceType/* IS_DESKTOP */.yn && (promosData === null || promosData === void 0 ? void 0 : promosData.length) > 1,
            showDots: !checkClientDeviceType/* IS_DESKTOP */.yn,
            children: promosData.map(function(promoData, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponsAndVouchers_PromoSlide, {
                    promoData: promoData
                }, index);
            })
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_PromoSlider = (PromoSlider);


/***/ }),

/***/ 293992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DigitalShowroomAds_ReasonModalHOC; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
;// CONCATENATED MODULE: ./src/utils/useClosePopupFromOutsideClick.js

function useClosePopupFromOutsideClick(referenceToDomElement, toggleClose, props) {
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        var ref;
        if (!((ref = e.composedPath()) === null || ref === void 0 ? void 0 : ref.includes(referenceToDomElement.current))) {
            e.stopPropagation();
            toggleClose(props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.toggleStatus);
        }
    };
}
/* harmony default export */ var utils_useClosePopupFromOutsideClick = (useClosePopupFromOutsideClick);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModal.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  width: 20px;\n  margin-left: ",
        "rem;\n  transform: rotateZ(180deg);\n  margin-top: ",
        "rem;\n  box-shadow: 0px -6px 12px 2px rgb(0 0 0 / 30%);\n  ",
        ";\n\n  &:before {\n    content: '';\n    border-top: 10px solid white;\n    border-right: 10px solid transparent;\n    border-left: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PointingArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PointingArrow",
    componentId: "sc-6444d3ae-0"
})(_templateObject(), function(props) {
    return props.ml || 0;
}, function(props) {
    return props.mt || 0;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.translateX) && (props === null || props === void 0 ? void 0 : props.translateY) && "transform : translate(".concat(props === null || props === void 0 ? void 0 : props.translateX, "rem , ").concat(props === null || props === void 0 ? void 0 : props.translateY, "rem) rotate(180deg)");
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js





function ReasonModalHOC(props) {
    var elementReferenceForOutsideClick = (0,react.useRef)();
    var closePopupForParticularId = {
        id: props.id,
        toggleStatus: false
    };
    utils_useClosePopupFromOutsideClick(elementReferenceForOutsideClick, props.toggleAdReasonModal, closePopupForParticularId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PointingArrow, {
                ml: props.ml,
                translateX: props.translateX,
                translateY: props.translateY,
                mt: props.mt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    zIndex: 1
                },
                ref: elementReferenceForOutsideClick,
                className: props.class,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(props.reasonModal, {})
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_ReasonModalHOC = (ReasonModalHOC);


/***/ }),

/***/ 916490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MiddleBody_DesktopDsAds; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/utils/removeDsAdsRouteLink.js
var removeDsAdsRouteLink = __webpack_require__(295218);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(467313);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js + 2 modules
var ReasonModalHOC = __webpack_require__(293992);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/VerticalReasonModal.js



function VerticalReasonModal(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pl20px flex flex-column justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex pt20px pb20px top-section fw6",
                children: [
                    "You are seeing this Ad",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "because owner of this",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "website is using the free",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "version"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-column pb20px pt20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex black-90 fw6",
                        children: [
                            "if you own this website",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "then you can remove this."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pa12px vertical-removead-section mt12px",
                        onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center fw7",
                            children: "Remove this Ad"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_VerticalReasonModal = (VerticalReasonModal);

// EXTERNAL MODULE: ./src/utils/checkIfThemePreview.js
var checkIfThemePreview = __webpack_require__(115483);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(527941);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/DesktopDsAds.js











function DesktopDsAds(props) {
    var toggleAdReasonModal = function toggleAdReasonModal() {
        setShowDesktopAdReasonModal(!showDesktopAdReasonModal);
    };
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), showDesktopAdReasonModal = ref3[0], setShowDesktopAdReasonModal = ref3[1];
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var isPreview = (0,checkIfThemePreview/* default */.Z)();
    if (deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf) return null;
    return !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: deviceWidth/* deviceWidth */.o > constants/* MAX_MOBILE_WIDTH */.Cf && ((ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.non_premium_ad_url_desktop_vertical) && !(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.is_demo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-column digital-showroom__ads_footer items-end \n              digital-showroom__ads__sticky_on_header ".concat(props.mr, " ").concat(props.pt, " ").concat(props.mb, " ").concat(props.ml),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex f12px items-start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex container-width fw4 mb6px vertical-ad-text-color pointer",
                        onClick: function() {
                            return setShowDesktopAdReasonModal(true);
                        },
                        children: [
                            "Why I am seeing This?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pointer flex ml36px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                        size: 16,
                                        secondaryColor: "#7F7F7F"
                                    }),
                                    showDesktopAdReasonModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonModalHOC/* default */.Z, {
                                        toggleAdReasonModal: toggleAdReasonModal,
                                        reasonModal: DigitalShowroomAds_VerticalReasonModal,
                                        mt: 1.45,
                                        ml: -1.21,
                                        translateX: 0,
                                        translateY: 0,
                                        className: "vertical-reason-modal"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex container-width gif-height pointer",
                    onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                        unoptimized: true,
                        src: (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.non_premium_ad_url_desktop_vertical,
                        width: 187,
                        height: 635,
                        loading: "lazy",
                        decoding: "async"
                    })
                })
            ]
        })
    }, props.id);
}
/* harmony default export */ var MiddleBody_DesktopDsAds = (DesktopDsAds);


/***/ }),

/***/ 964604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

function useGetAnimationTranslation(showFilterDrawer) {
    var getPageTopLeft = function getPageTopLeft(el) {
        var rect = el === null || el === void 0 ? void 0 : el.getBoundingClientRect();
        var docEl = document === null || document === void 0 ? void 0 : document.documentElement;
        return {
            left: (rect === null || rect === void 0 ? void 0 : rect.left) + (window.pageXOffset || docEl.scrollLeft || 0),
            top: (rect === null || rect === void 0 ? void 0 : rect.top) + (window.pageYOffset || docEl.scrollTop || 0)
        };
    };
    var translationDistanceForAnimation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var middleBodyContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var leftWhenDrawerClosed = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var leftWhenDrawerOpened = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!leftWhenDrawerClosed.current || !leftWhenDrawerOpened.current) {
            if (!showFilterDrawer) {
                var ref;
                leftWhenDrawerClosed.current = (ref = getPageTopLeft(middleBodyContainerRef.current)) === null || ref === void 0 ? void 0 : ref.left;
            } else {
                setTimeout(function() {
                    var ref;
                    leftWhenDrawerOpened.current = (ref = getPageTopLeft(middleBodyContainerRef.current)) === null || ref === void 0 ? void 0 : ref.left;
                    translationDistanceForAnimation.current = leftWhenDrawerOpened.current - leftWhenDrawerClosed.current;
                }, 600);
            }
        }
    }, [
        showFilterDrawer
    ]);
    return {
        translationDistanceForAnimation: translationDistanceForAnimation,
        middleBodyContainerRef: middleBodyContainerRef
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useGetAnimationTranslation);


/***/ }),

/***/ 343955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ListingHeading; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "Z5": function() { return /* binding */ AllCategorySection; },
/* harmony export */   "bu": function() { return /* binding */ AllCategoryButton; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "rV": function() { return /* binding */ MiddleBodyAdWrapper; }
/* harmony export */ });
/* unused harmony export Listing */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(307297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(150066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  width: ",
        ";\n  display: flex;\n  max-width: 1600px;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n  position: relative;\n  margin: 0 auto;\n  ",
        "\n  @media screen and (max-width: 767px) {\n    padding-top: 0;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  display: grid;\n  grid-template-rows: auto;\n  justify-items: center;\n  box-sizing: border-box;\n  margin-bottom: 3rem;\n\n  @media screen and (min-width: 767px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    row-gap: 2rem;\n    column-gap: 1.5rem;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 1.5rem;\n    column-gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000000;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n\n  @media screen and (min-width: 767px) {\n    font-size: 28px;\n    padding: 0 0;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 20px;\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  position: sticky;\n  bottom: 5%;\n  z-index: 5;\n  background: transparent;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  border-radius: 30px;\n  box-shadow: 0px 16px 36px #0000004a;\n  background: ",
        " 0% 0% no-repeat padding-box;\n  color: ",
        ";\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n    padding: 16px 40px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    padding: 14px 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-column-start: 1;\n  grid-column-end: 3;\n  background: ",
        ";\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  background: #fff;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

function slideInAnimate() {
    return "\n    animation-name: slide-in;\n    animation-duration: 0.5s;\n    transform : translateX(50px);\n\n    @keyframes slide-in {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n          transform : translateX(50px);\n      }\n    }\n    ";
}
function slideOutAnimate(trasnlationDist) {
    return "\n    animation-name: slide-out;\n    animation-duration: 0.50s;\n\n    @keyframes slide-out {\n      from {\n          transform : translateX(50px);\n      }\n      to {\n        transform : translateX(-".concat(trasnlationDist - 50, "px);\n      }\n    }\n    ");
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "Container",
    componentId: "sc-81fe99c9-0"
})(_templateObject(), function(props) {
    return props.isBuilderMobile ? "4rem 16px 2rem" : "4rem 0 2rem";
}, function(props) {
    return props.isBuilderMobile ? "100%" : "80%";
}, function(props) {
    return props.showFilterDrawer === null ? "" : props.showFilterDrawer ? slideInAnimate() : slideOutAnimate(props.trasnlationDist);
});
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    displayName: "Heading",
    componentId: "sc-81fe99c9-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var Listing = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Listing",
    componentId: "sc-81fe99c9-2"
})(_templateObject2());
var ListingHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "ListingHeading",
    componentId: "sc-81fe99c9-3"
})(_templateObject3());
var AllCategorySection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategorySection",
    componentId: "sc-81fe99c9-4"
})(_templateObject4());
var AllCategoryButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategoryButton",
    componentId: "sc-81fe99c9-5"
})(_templateObject5(), function(props) {
    return props.backgroundColor || "#ffffff";
}, function(props) {
    return props.backgroundColor ? "#ffffff" : "#000000";
});
var AdContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AdContainer",
    componentId: "sc-81fe99c9-6"
})(_templateObject6(), function(props) {
    return props.backgroundColor || "#FFFFFF";
}, function(props) {
    return props.paddingTop || 0;
}, function(props) {
    return props.paddingBottom || 0;
});
var MiddleBodyAdWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MiddleBodyAdWrapper",
    componentId: "sc-81fe99c9-7"
})(_templateObject7());


/***/ }),

/***/ 391612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FilterDrawer_FilterDrawer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/assets/svgExports/CloseIconGrey.js
var CloseIconGrey = __webpack_require__(273467);
;// CONCATENATED MODULE: ./src/assets/svgExports/ColoredRectangle.js

function ColoredRectangle(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            y: "0.00390625",
            width: "18",
            height: "18",
            fill: (props === null || props === void 0 ? void 0 : props.color) ? props === null || props === void 0 ? void 0 : props.color : "none"
        })
    });
}

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/utils.js
var utils = __webpack_require__(708710);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterComponent/FilterComponent.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 24px;\n  margin-left: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #eaeaea;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 600;\n  font-size: 14px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-top: 14px;\n  overflow: hidden;\n  white-space: nowrap;\n  align-items: center;\n  text-overflow: ellipsis;\n  > input {\n    transform: scale(1.25);\n  }\n  > label {\n    max-width: 200px;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-top: 14px;\n  cursor: pointer;\n  font-weight: 300;\n  font-size: 14px;\n  margin-left: 18px;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  margin-top: 2px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  font-weight: 300;\n  font-size: 14px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background: #f7f7f7;\n  min-height: 90vh;\n  border-right: 1px solid #ededed;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 32vw;\n  padding: 16px;\n  ",
        ";\n  border-bottom: 1px solid #ededed;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction column;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction row;\n  margin-top: 20px;\n  align-items: center;\n   > input {\n    transform: scale(1.25);\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var FilterComponentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentContainer",
    componentId: "sc-18ce1c48-0"
})(_templateObject());
var FilterComponentHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentHeading",
    componentId: "sc-18ce1c48-1"
})(_templateObject1());
var FilterComponentListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentListContainer",
    componentId: "sc-18ce1c48-2"
})(_templateObject2());
var FilterComponentListElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentListElement",
    componentId: "sc-18ce1c48-3"
})(_templateObject3());
var FilterComponentViewMore = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentViewMore",
    componentId: "sc-18ce1c48-4"
})(_templateObject4(), (0,getThemeColor/* getThemeColor */.p)());
var FilterColoredComponent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterColoredComponent",
    componentId: "sc-18ce1c48-5"
})(_templateObject5());
var FilterComponentText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentText",
    componentId: "sc-18ce1c48-6"
})(_templateObject6());
var FilterComponentMobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentMobileContainer",
    componentId: "sc-18ce1c48-7"
})(_templateObject7(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.loader) ? "pointer-events: none" : "";
});
var FilterComponentMobileHeadingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentMobileHeadingContainer",
    componentId: "sc-18ce1c48-8"
})(_templateObject8());
var FilterComponentMobileHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentMobileHeading",
    componentId: "sc-18ce1c48-9"
})(_templateObject9(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isSelected) && "background : #FFFFFF";
});
var FilterComponentMobileHeadingText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentMobileHeadingText",
    componentId: "sc-18ce1c48-10"
})(_templateObject10());
var FilterComponentMobileRightContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentMobileRightContainer",
    componentId: "sc-18ce1c48-11"
})(_templateObject11());
var FilterComponentMobileInput = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentMobileInput",
    componentId: "sc-18ce1c48-12"
})(_templateObject12());

// EXTERNAL MODULE: ./src/containers/Collections/useGetTypeIdFromCanonicalDataStore.js
var useGetTypeIdFromCanonicalDataStore = __webpack_require__(130553);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterComponent/FilterComponent.js










var MAX_ITEMS_SHOW_LIMIT = 5;
function FilterComponent(props) {
    var setSelectedFilter = function setSelectedFilter() {
        var newSelectedFilterForMobile = filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.find(function(item) {
            return item.name === (selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.name);
        });
        newSelectedFilterForMobile && setSelectedMobileFilter(newSelectedFilterForMobile);
    };
    var getFilterType = function getFilterType() {
        if (isTypeCategory) return 2;
        else if (isTypeCollection) return 1;
        return;
    };
    var handleViewMoreClick = function handleViewMoreClick(ListElement) {
        var length = (ListElement === null || ListElement === void 0 ? void 0 : ListElement.length) ? ListElement === null || ListElement === void 0 ? void 0 : ListElement.length : ListElement;
        setShowItemsLimit(length);
    };
    var handleSelectedMobileFilter = function handleSelectedMobileFilter(itemName) {
        var newSelectedFilterForMobile = filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.find(function(item) {
            return item.name === itemName;
        });
        newSelectedFilterForMobile && setSelectedMobileFilter(newSelectedFilterForMobile);
    };
    var handleCheckboxClick = /**
   * set is_selected value for sub_filter and changes filterApplied counter and saves
   * new filterOptions in reducer.
   * @param {*} e event on checkbox
   * @param {*} filterOptionName the name of filter option that is currently shown
   * @param {*} subFilterName the name of subfilter that is checked/unchecked by user.
   */ function handleCheckboxClick(e, filterOptionName, subFilterName) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        var tempFilterOptions = filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.slice(filteredOptions, filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length);
        for(var i = 0; i < (tempFilterOptions === null || tempFilterOptions === void 0 ? void 0 : tempFilterOptions.length); i++){
            var ref;
            if (filterOptionName === ((ref = tempFilterOptions[i]) === null || ref === void 0 ? void 0 : ref.name)) {
                var ref1, ref2;
                for(var j = 0; j < ((ref1 = tempFilterOptions[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sub_filters) === null || ref2 === void 0 ? void 0 : ref2.length); j++){
                    var ref3;
                    if (subFilterName === ((ref3 = tempFilterOptions[i].sub_filters[j]) === null || ref3 === void 0 ? void 0 : ref3.name)) {
                        e.target.checked ? tempFilterOptions[i].sub_filters[j]["is_selected"] = true : tempFilterOptions[i].sub_filters[j]["is_selected"] = false;
                        break;
                    }
                }
            }
        }
        setToggleClick(!toggleClick);
        var filterCounter = e.target.checked ? constants/* FILTER_COUNTER_OPTIONS.INC */.zO.INC : constants/* FILTER_COUNTER_OPTIONS.DEC */.zO.DEC;
        dispatch((0,catalog/* filtersCounter */.Ds)(filterCounter));
        dispatch((0,catalog/* saveFilteredOptions */.Pu)(tempFilterOptions));
        (0,utils/* setMB7SortAndFilterConfig */.lr)({
            filterAppliedCounterChanged: true
        });
    };
    var renderViewMore = function renderViewMore(ListElement) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentViewMore, {
            onClick: function() {
                handleViewMoreClick(ListElement);
            },
            children: [
                "+ ",
                (ListElement === null || ListElement === void 0 ? void 0 : ListElement.length) - MAX_ITEMS_SHOW_LIMIT,
                " more"
            ]
        });
    };
    var renderViewLess = function renderViewLess(ListElement) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentViewMore, {
            onClick: function() {
                handleViewMoreClick(ListElement);
            },
            children: "View Less"
        });
    };
    var getTotalItemsCheckCount = function getTotalItemsCheckCount(filterOptionItem) {
        var ref;
        var totalCheckedCount = 0;
        !!(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.sub_filters) && !!(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : (ref = filterOptionItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && (filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.sub_filters.forEach(function(item) {
            item.is_selected && totalCheckedCount++;
        }));
        return totalCheckedCount;
    };
    var removeCollectionOrCategoryFromPLP = function removeCollectionOrCategoryFromPLP(filterType) {
        if ((props === null || props === void 0 ? void 0 : props.hideCollectionFilter) && filterType === 1) {
            return false;
        }
        if ((props === null || props === void 0 ? void 0 : props.hideCategoryFilter) && filterType === 2) {
            return false;
        }
        if ((props === null || props === void 0 ? void 0 : props.hideTags) && filterType === 3) {
            return false;
        }
        if (isTypeCategory && filterType === 2) {
            return false;
        } else if (isTypeCollection && filterType === 1) {
            return false;
        }
        return true;
    };
    var renderMobileFilterComponent = function renderMobileFilterComponent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentMobileContainer, {
            loader: filterOptionLoader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentMobileHeadingContainer, {
                    children: !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function(filterOptionItem) {
                        var ref;
                        return !!(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : (ref = filterOptionItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && removeCollectionOrCategoryFromPLP(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentMobileHeading, {
                            isSelected: (filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.name) === (selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.name),
                            onClick: function() {
                                handleSelectedMobileFilter(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.name);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentMobileHeadingText, {
                                children: [
                                    filterOptionItem.name,
                                    !!getTotalItemsCheckCount(filterOptionItem) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fw3 ml8px",
                                        children: "(".concat(getTotalItemsCheckCount(filterOptionItem), ")")
                                    })
                                ]
                            })
                        }, "".concat(filterOptionItem.name).concat(filterOptionItem.type));
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentMobileRightContainer, {
                    children: (selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.sub_filters) && selectedMobileFilter.sub_filters.map(function(item) {
                        return removeCollectionOrCategoryFromPLP(selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.type) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentMobileInput, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    className: "ml24px pointer",
                                    checked: item === null || item === void 0 ? void 0 : item.is_selected,
                                    id: "".concat(selectedMobileFilter.name, "-").concat(item.name),
                                    onClick: function(e) {
                                        return handleCheckboxClick(e, selectedMobileFilter.name, item.name);
                                    }
                                }),
                                selectedMobileFilter.name === constants/* COLOR_FILTER_OPTION */.uh && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "".concat(selectedMobileFilter.name, "-").concat(item.name),
                                    className: "pointer ml10px mt2px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredRectangle, {
                                        color: item === null || item === void 0 ? void 0 : item.colour_code
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "".concat(selectedMobileFilter.name, "-").concat(item.name),
                                    className: "pointer ml10px fw3 f14px",
                                    children: item.name
                                })
                            ]
                        }, "subFilter-".concat(item === null || item === void 0 ? void 0 : item.name, "-").concat(item === null || item === void 0 ? void 0 : item.id));
                    })
                })
            ]
        });
    };
    var renderDesktopFilterComponent = function renderDesktopFilterComponent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function(filterOption) {
                var ref, ref1, ref2, ref3;
                return removeCollectionOrCategoryFromPLP(filterOption === null || filterOption === void 0 ? void 0 : filterOption.type) && !!(filterOption === null || filterOption === void 0 ? void 0 : (ref = filterOption.sub_filters) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentHeading, {
                            children: [
                                filterOption.name,
                                !!getTotalItemsCheckCount(filterOption) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "fw3 ml8px",
                                    children: "(".concat(getTotalItemsCheckCount(filterOption), ")")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentListContainer, {
                            children: [
                                filterOption === null || filterOption === void 0 ? void 0 : (ref1 = filterOption.sub_filters) === null || ref1 === void 0 ? void 0 : ref1.slice(0, showItemsLimit).map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentListElement, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                className: "ml4px pointer",
                                                checked: item === null || item === void 0 ? void 0 : item.is_selected,
                                                id: "".concat(filterOption.name, "-").concat(item.name),
                                                onClick: function(e) {
                                                    return handleCheckboxClick(e, filterOption.name, item.name);
                                                }
                                            }),
                                            filterOption.name === constants/* COLOR_FILTER_OPTION */.uh && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "".concat(filterOption.name, "-").concat(item.name),
                                                className: "pointer ml10px mt2px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredRectangle, {
                                                    color: item === null || item === void 0 ? void 0 : item.colour_code
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "".concat(filterOption.name, "-").concat(item.name),
                                                className: "pointer ml10px fw3 f14px",
                                                children: item.name
                                            })
                                        ]
                                    }, "".concat(filterOption.name, "-").concat(item.name, "-filterOption-subFilters"));
                                }),
                                (filterOption === null || filterOption === void 0 ? void 0 : (ref2 = filterOption.sub_filters) === null || ref2 === void 0 ? void 0 : ref2.length) > showItemsLimit && renderViewMore(filterOption === null || filterOption === void 0 ? void 0 : filterOption.sub_filters),
                                !!((filterOption === null || filterOption === void 0 ? void 0 : (ref3 = filterOption.sub_filters) === null || ref3 === void 0 ? void 0 : ref3.length) === showItemsLimit && showItemsLimit > MAX_ITEMS_SHOW_LIMIT) && renderViewLess(MAX_ITEMS_SHOW_LIMIT)
                            ]
                        })
                    ]
                }, "".concat(filterOption.name, "-filterOption")) : null;
            }))
        });
    };
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(MAX_ITEMS_SHOW_LIMIT), showItemsLimit = ref[0], setShowItemsLimit = ref[1];
    var ref1 = (0,react.useState)({}), selectedMobileFilter = ref1[0], setSelectedMobileFilter = ref1[1];
    var ref2 = (0,react.useState)(false), toggleClick = ref2[0], setToggleClick = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return {
            filteredOptions: state.catalogReducer.filteredOptions,
            filterOptionLoader: state.commonReducer.filterOptionLoader,
            hideFiltersCategoryAndCollection: state.commonReducer.hideFiltersCategoryAndCollection
        };
    }), filteredOptions = ref3.filteredOptions, filterOptionLoader = ref3.filterOptionLoader, hideFiltersCategoryAndCollection = ref3.hideFiltersCategoryAndCollection;
    (0,react.useEffect)(function() {
        !!filteredOptions && !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && isMobile && hideFiltersCategoryAndCollection ? setSelectedMobileFilter(filteredOptions[2] || {}) : removeCollectionOrCategoryFromPLP(getFilterType()) ? setSelectedMobileFilter(filteredOptions[0] || {}) : setSelectedMobileFilter(filteredOptions[1] || {});
    }, [
        hideFiltersCategoryAndCollection
    ]);
    (0,react.useEffect)(function() {
        if (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) {
            setSelectedFilter();
        }
    }, [
        toggleClick
    ]);
    (0,react.useEffect)(function() {
        setSelectedFilter();
    }, [
        filteredOptions
    ]);
    var ref4 = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)(), isTypeCategory = ref4.isTypeCategory, isTypeCollection = ref4.isTypeCollection;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? renderMobileFilterComponent() : renderDesktopFilterComponent()
    });
}
/* harmony default export */ var FilterComponent_FilterComponent = (FilterComponent);

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.styles.js

function FilterDrawer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    FilterDrawer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 56px;\n  border-bottom: 1px solid #eaeaea;\n  border-top: 1px solid #eaeaea;\n  @media screen and (max-width: ",
        "px) {\n    min-height: 56px;\n    z-index: 7;\n  }\n"
    ]);
    FilterDrawer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 700;\n  font-size: 16px;\n  width: 100%;\n  margin-left: 16px;\n  align-items: center;\n"
    ]);
    FilterDrawer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  width: 124px;\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n"
    ]);
    FilterDrawer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto;\n  height: calc(100vh - ",
        "px);\n  padding-bottom: 40px;\n  ",
        ";\n"
    ]);
    FilterDrawer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var FilterDrawerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterDrawerContainer",
    componentId: "sc-9a833bb7-0"
})(FilterDrawer_styles_templateObject());
var FilterHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterHeading",
    componentId: "sc-9a833bb7-1"
})(FilterDrawer_styles_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf);
var FilterHeadingText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterHeadingText",
    componentId: "sc-9a833bb7-2"
})(FilterDrawer_styles_templateObject2());
var ClearAllCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ClearAllCta",
    componentId: "sc-9a833bb7-3"
})(FilterDrawer_styles_templateObject3(), (0,getThemeColor/* getThemeColor */.p)());
var FilterDrawerDesktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterDrawerDesktop",
    componentId: "sc-9a833bb7-4"
})(FilterDrawer_styles_templateObject4(), function(props) {
    return props === null || props === void 0 ? void 0 : props.headerHeight;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.loader) ? "pointer-events : none" : " ";
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.js











function FilterDrawer(props) {
    var handleClearAll = /**
   * resets the filterOptions = [] and filtereditems = []
   * and filteredApplied counter goes to 0
   * reset payload api gets called again
   */ function handleClearAll() {
        dispatch((0,catalog/* filtersCounter */.Ds)(constants/* DEFAULT_FILTER_COUNT_VALUE */.Tv, true));
        if (typeId) {
            router.reload(router === null || router === void 0 ? void 0 : router.asPath);
            return;
        }
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: []
        };
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload));
    };
    var renderFilterDrawerHeading = function renderFilterDrawerHeading() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterHeading, {
            ref: filterHeadingRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterHeadingText, {
                    children: "Filters"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClearAllCta, {
                    onClick: handleClearAll,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "pointer",
                            style: {
                                whiteSpace: "nowrap"
                            },
                            children: "Clear All"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: function(e) {
                                e.stopPropagation();
                                handleShowFilterDrawer();
                            },
                            className: "ml12px flex align-center pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconGrey/* CloseIconGrey */.U, {})
                        })
                    ]
                })
            ]
        });
    };
    var renderFilterDrawerDesktop = function renderFilterDrawerDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawerDesktop, {
            ref: filterDrawerRef,
            loader: filterOptionLoader,
            headerHeight: FilterDrawerTopMargin,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponent_FilterComponent, {
                hideCollectionFilter: props.hideCollectionFilter,
                hideCategoryFilter: props.hideCategoryFilter,
                hideTags: props.hideTags
            })
        });
    };
    var renderFilterDrawerMobile = function renderFilterDrawerMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponent_FilterComponent, {
            hideCollectionFilter: props.hideCollectionFilter,
            hideCategoryFilter: props.hideCategoryFilter
        });
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var handleShowFilterDrawer = props.handleShowFilterDrawer;
    var filterDrawerRef = (0,react.useRef)();
    var filterHeadingRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), filterHeadingHeight = ref[0], setFilterHeadingHeight = ref[1];
    var ref1;
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref2, ref3;
        return {
            headerHeight: (ref1 = (ref = state.commonReducer) === null || ref === void 0 ? void 0 : (ref2 = ref.headerRef) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.current) === null || ref3 === void 0 ? void 0 : ref3.clientHeight) !== null && ref1 !== void 0 ? ref1 : 0,
            sortType: state.catalogReducer.sortType,
            storeData: state.storeReducer.store,
            filterOptionLoader: state.commonReducer.filterOptionLoader
        };
    }), headerHeight = ref2.headerHeight, sortType = ref2.sortType, storeData = ref2.storeData, filterOptionLoader = ref2.filterOptionLoader;
    var typeId = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)().typeId;
    (0,react.useEffect)(function() {
        if (filterHeadingRef.current) {
            var ref;
            setFilterHeadingHeight((ref = filterHeadingRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (!isMobile) {
            var styleOverflowHidden = function() {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            };
            var styleOverflowAuto = function() {
                document.getElementsByTagName("body")[0].style.overflowY = "auto";
            };
            if (filterDrawerRef.current) {
                var ref, ref1;
                (ref = filterDrawerRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("mouseover", styleOverflowHidden);
                (ref1 = filterDrawerRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("mouseout", styleOverflowAuto);
                return function() {
                    var ref, ref1;
                    (ref = filterDrawerRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("mouseover", styleOverflowHidden);
                    (ref1 = filterDrawerRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("mouseout", styleOverflowAuto);
                };
            }
        }
    }, []);
    var FilterDrawerTopMargin = headerHeight + filterHeadingHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterDrawerContainer, {
        children: [
            renderFilterDrawerHeading(),
            isMobile ? renderFilterDrawerMobile() : renderFilterDrawerDesktop()
        ]
    });
}
/* harmony default export */ var FilterDrawer_FilterDrawer = (FilterDrawer);


/***/ }),

/***/ 708710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ DEFAULT_GET_ITEMS_API_PAGE_SIZE; },
/* harmony export */   "FM": function() { return /* binding */ MB7_SORT_FILTER_TEMP_STORAGE_KEY; },
/* harmony export */   "Tr": function() { return /* binding */ getStoredMB7SortAndFilterConfig; },
/* harmony export */   "Wu": function() { return /* binding */ scrollIfItemPreviouslyClicked; },
/* harmony export */   "lr": function() { return /* binding */ setMB7SortAndFilterConfig; },
/* harmony export */   "vU": function() { return /* binding */ getPaginatedItemsPerPage; },
/* harmony export */   "ve": function() { return /* binding */ isCustomTag; }
/* harmony export */ });
/* unused harmony export MB7_SORT_FILTER_STORAGE_KEY */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(287243);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);
/* harmony import */ var _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(644779);




var MB7_SORT_FILTER_STORAGE_KEY = "mb7SortAndFilterConfig";
var MB7_SORT_FILTER_TEMP_STORAGE_KEY = "mb7SortAndFilterConfigTemp";
var DEFAULT_GET_ITEMS_API_PAGE_SIZE = 20;
function scrollIfItemPreviouslyClicked() {
    var scrollConfig = (0,_utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__/* .scrollOnPageLoad */ .l)();
    if (scrollConfig.toScroll) {
        try {
            var y_scroll = scrollConfig.y_scroll;
            setTimeout(function() {
                sessionStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CLICKED_ITEM_OBJ */ .uI);
                window.scrollTo({
                    top: y_scroll
                });
            }, 300);
        } catch (err) {
            console.log("timeout time error:", err);
        }
    }
}
function getStoredMB7SortAndFilterConfig() {
    if (_utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY)) {
        return _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY);
    }
    return {
        filterAppliedCounter: 0,
        sortType: 0,
        collectionId: null,
        cid: null,
        isNextPage: true,
        pageNo: 1,
        filteredItems: [],
        filteredOptions: [],
        allowReset: true,
        filterAppliedCounterChanged: false,
        sortTypeChanged: false
    };
}
function setMB7SortAndFilterConfig(data) {
    var temp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var currentStoredData = getStoredMB7SortAndFilterConfig();
    var newData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, currentStoredData, data);
    if (temp) {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_TEMP_STORAGE_KEY, newData);
    } else {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_STORAGE_KEY, newData);
    }
}
function getPaginatedItemsPerPage() {
    var gridAndPaginationConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isMobile = arguments.length > 1 ? arguments[1] : void 0;
    var tmp = gridAndPaginationConfig.num_products_desktop, numProductsDesktop = tmp === void 0 ? DEFAULT_GET_ITEMS_API_PAGE_SIZE : tmp, tmp1 = gridAndPaginationConfig.num_products_mobile, numProductsMobile = tmp1 === void 0 ? DEFAULT_GET_ITEMS_API_PAGE_SIZE : tmp1;
    var value = isMobile ? numProductsMobile : numProductsDesktop;
    return value && !isNaN(Number(value)) ? Number(value) : DEFAULT_GET_ITEMS_API_PAGE_SIZE;
}
function isCustomTag(categoryData) {
    return (categoryData === null || categoryData === void 0 ? void 0 : categoryData.hasOwnProperty("is_custom_tag")) ? 1 : 0;
}


/***/ }),

/***/ 527941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ NextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(425675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/NextImage.tsx
// import React, { useState } from 'react';
// import Image, { ImageProps } from 'next/image';
// /* --- shimmer helpers --- */
// const toBase64 = (str: string) =>
//   typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str);
// const shimmer = (w = 700, h = 475) => `
// <svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
//   <defs>
//     <linearGradient id="g">
//       <stop stop-color="#f6f7f8" offset="0%" />
//       <stop stop-color="#eaeaea" offset="50%" />
//       <stop stop-color="#f6f7f8" offset="100%" />
//     </linearGradient>
//   </defs>
//   <rect width="${w}" height="${h}" fill="#f6f7f8"/>
//   <rect id="r" width="${w}" height="${h}" fill="url(#g)">
//     <animateTransform attributeName="transform" attributeType="XML"
//       type="translate" from="-${w} 0" to="${w} 0" dur="1s" repeatCount="indefinite" />
//   </rect>
// </svg>`;
// const shimmerDataURL = (w?: number, h?: number) =>
//   `data:image/svg+xml;base64,${toBase64(shimmer(w ?? 700, h ?? 475))}`;
// /* --- typed props like your original component --- */
// type TNextImage<T extends boolean = false> = T extends true
//   ? { useDefaultHTMLTag: true } & React.ImgHTMLAttributes<HTMLImageElement>
//   : { useDefaultHTMLTag?: false } & ImageProps;
// /* --- main component --- */
// export default function NextImage<T extends boolean = false>(props: TNextImage<T>) {
//   const [normalImageLoaded, setNormalImageLoaded] = useState(false);
//   const [loaded, setLoaded] = useState(false);
//   // native <img> mode
//   if ((props as any).useDefaultHTMLTag) {
//     const {
//       onLoad,
//       style,
//       width = '100%',
//       height = '100%',
//       ...rest
//     } = props as any;
//     const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
//       setNormalImageLoaded(true);
//       if (onLoad) onLoad(e);
//     };
//     // ensure wrapper reserves space; if width/height provided use them, fallback to a default height
//     const wrapperStyle: React.CSSProperties = {
//       display: 'inline-block',
//       position: 'relative',
//       overflow: 'hidden',
//       width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
//       height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
//       backgroundImage: !normalImageLoaded ? `url("${shimmerDataURL(16, 9)}")` : undefined,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       ...((style as React.CSSProperties) || {}),
//     };
//     return (
//       <span style={wrapperStyle}>
//         <img
//           {...(rest as React.ImgHTMLAttributes<HTMLImageElement>)}
//           onLoad={handleLoad}
//         />
//       </span>
//     );
//   }
//   // next/image mode
//   const nextProps = props as ImageProps;
//   const { width, height, onLoadingComplete, style } = nextProps as any;
//   // compute small blurDataURL from shimmer (you can also pass a custom blurDataURL prop)
//   const blurData = shimmerDataURL(
//     typeof width === 'number' ? width : 700,
//     typeof height === 'number' ? height : 475
//   );
//   // wrapper ensures a placeholder background while the image is loading
//   const wrapperStyle: React.CSSProperties = {
//     position: nextProps.layout === 'fill' ? 'absolute' : 'relative',
//     display: 'block',
//     width:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : width
//           ? typeof width === 'number'
//             ? `${width}px`
//             : width
//           : undefined,
//     height:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : height
//           ? typeof height === 'number'
//             ? `${height}px`
//             : height
//           : undefined,
//     backgroundImage: !loaded ? `url("${blurData}")` : undefined,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     ...((style as React.CSSProperties) || {}),
//   };
//   return (
//     <div style={wrapperStyle}>
//       <Image
//         {...nextProps}
//         // keep placeholder prop so Next shows blur if it can, but we also have wrapper background as fallback
//         placeholder="blur"
//         blurDataURL={blurData}
//         onLoadingComplete={(res) => {
//           setLoaded(true);
//           if (onLoadingComplete) onLoadingComplete(res);
//         }}
//       />
//     </div>
//   );
// }





function NextImage(props) {
    if (props.useDefaultHTMLTag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        unoptimized: true
    }));
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/index.ts



/***/ }),

/***/ 368464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* reexport safe */ _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__.X; }
/* harmony export */ });
/* harmony import */ var _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(639996);



/***/ }),

/***/ 333636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SortingAndFiltersTab_SortingAndFiltersTab; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/assets/svgExports/MobileFilterIcon.js
var MobileFilterIcon = __webpack_require__(472933);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/assets/svgExports/DropDownArrowSort.js
var DropDownArrowSort = __webpack_require__(350541);
// EXTERNAL MODULE: ./src/utils/useIsClickOutside.js
var useIsClickOutside = __webpack_require__(305305);
;// CONCATENATED MODULE: ./src/components/SortingAndFiltersTab/Components/SortByCtaDesktop/SortByCtaDesktop.js





function SortByCtaDesktop(props) {
    var selectedSortingText = props.selectedSortingText, toggleShowDropDown = props.toggleShowDropDown, showDropDown = props.showDropDown, setShowDropDown = props.setShowDropDown, handleSortType = props.handleSortType;
    var dropDownElementRef = (0,react.useRef)();
    (0,useIsClickOutside/* default */.Z)(dropDownElementRef, setShowDropDown, false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: dropDownElementRef,
        className: "sortingTab",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sortingTabText",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Sort by: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "fw6 ml6px",
                        children: selectedSortingText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: toggleShowDropDown,
                className: "dropDownArrow pointer",
                style: {
                    "--showDropDownAngle": showDropDown ? "180deg" : "0deg"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowSort/* DropDownArrowSort */.b, {})
            }),
            showDropDown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dropDownContainer",
                children: constants/* SortList.map */.j.map(function(sortItem, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mb20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "pointer",
                                name: "selectedSortingType",
                                type: "radio",
                                id: "sortinglist-".concat(sortItem.name),
                                value: sortItem.type,
                                checked: sortItem.name === selectedSortingText,
                                onChange: function(e) {
                                    return handleSortType(e, sortItem);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "f14px ml10px pointer",
                                htmlFor: "sortinglist-".concat(sortItem.name),
                                children: sortItem.name
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/assets/svgExports/MobileSortByArrow.js
var MobileSortByArrow = __webpack_require__(272468);
;// CONCATENATED MODULE: ./src/components/SortingAndFiltersTab/Components/SortByCtaMobile/SortByCtaMobile.js




function SortByCtaMobile(props) {
    var selectedSortingText = props.selectedSortingText, toggleShowDropDown = props.toggleShowDropDown, showDropDown = props.showDropDown, handleSortType = props.handleSortType, isSortOpenAndMobile = props.isSortOpenAndMobile, isFilterOpenAndMobile = props.isFilterOpenAndMobile;
    (0,react.useEffect)(function() {
        if (showDropDown) {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        } else {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        }
        return function() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        };
    }, [
        showDropDown
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sortingTabMobile",
        onClick: toggleShowDropDown,
        children: [
            !isSortOpenAndMobile() && !isFilterOpenAndMobile() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mr10px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortByArrow/* MobileSortByArrow */.P, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center",
                                style: {
                                    transform: "rotateZ(180deg)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortByArrow/* MobileSortByArrow */.P, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sortingTabText",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Sort by "
                        })
                    })
                ]
            }),
            showDropDown && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dropDownContainerMobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex sortByHeading",
                        children: [
                            "Sort by",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "borderDiv"
                            })
                        ]
                    }),
                    constants/* SortList.map */.j.map(function(sortItem, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb20px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "pointer",
                                    name: "selectedSortingType",
                                    type: "radio",
                                    id: "sortinglist-".concat(sortItem.name),
                                    value: sortItem.type,
                                    checked: sortItem.name === selectedSortingText,
                                    onChange: function(e) {
                                        return handleSortType(e, sortItem);
                                    },
                                    onClick: function(e) {
                                        return e.stopPropagation();
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "f14px ml10px pointer",
                                    onClick: function(e) {
                                        return e.stopPropagation();
                                    },
                                    htmlFor: "sortinglist-".concat(sortItem.name),
                                    children: sortItem.name
                                })
                            ]
                        }, idx);
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/hooks/useTriggerChangeTopHeightMobile.js
var useTriggerChangeTopHeightMobile = __webpack_require__(302876);
;// CONCATENATED MODULE: ./src/components/SortingAndFiltersTab/SortingAndFiltersTab.js










function SortingAndFiltersTab(props) {
    var handleSortType = function handleSortType(e, sortItem) {
        e.stopPropagation();
        dispatch((0,catalog/* setSortType */.Td)(sortItem.type));
        setSelectedSortingText(sortItem.name);
    };
    var toggleShowDropDown = function toggleShowDropDown(e) {
        e.stopPropagation();
        setShowDropDown(!showDropDown);
    };
    var isSortOpenAndMobile = function isSortOpenAndMobile() {
        return checkClientDeviceType/* IS_MOBILE */.q$ && showDropDown;
    };
    var isFilterOpenAndMobile = function isFilterOpenAndMobile() {
        return checkClientDeviceType/* IS_MOBILE */.q$ && props.showFilterDrawer;
    };
    var showFiltersCta = function showFiltersCta() {
        if (!checkClientDeviceType/* IS_MOBILE */.q$) {
            return !props.showFilterDrawer;
        }
        return true;
    };
    var isDrawerOpenAndMobile = function isDrawerOpenAndMobile() {
        return props.showFilterDrawer && checkClientDeviceType/* IS_MOBILE */.q$;
    };
    var handleShowFilterDrawer = props.handleShowFilterDrawer;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), showDropDown = ref[0], setShowDropDown = ref[1];
    var ref1 = (0,react.useState)(constants/* SortList.0.name */.j[0].name), selectedSortingText = ref1[0], setSelectedSortingText = ref1[1];
    var sortType = (0,es/* useSelector */.v9)(function(state) {
        return {
            sortType: state.catalogReducer.sortType
        };
    }).sortType;
    var showSortAndFilterMobileCta = (0,useTriggerChangeTopHeightMobile/* default */.Z)(props.middleBodyRef, props.showFilterDrawer, 150, 360);
    (0,react.useEffect)(function() {
        if (props.showFilterDrawer && checkClientDeviceType/* IS_MOBILE */.q$) {
            props.filterDrawerWrapperRef.current.scrollIntoView({
                behavior: "instant",
                block: "center"
            });
        }
    }, [
        props.showFilterDrawer
    ]);
    (0,react.useEffect)(function() {
        if (showDropDown) {
            props.middleBodyRef.current.scrollIntoView();
        }
    }, [
        sortType
    ]);
    if (!showSortAndFilterMobileCta && checkClientDeviceType/* IS_MOBILE */.q$) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "SortingAndFiltersTabWrapper ".concat(isDrawerOpenAndMobile() ? "Wrapper" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "SortingAndFiltersTab ".concat(isDrawerOpenAndMobile() ? "mobileDrawer" : ""),
            children: [
                showFiltersCta() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: isSortOpenAndMobile() ? toggleShowDropDown : handleShowFilterDrawer,
                    className: "filterTab",
                    children: [
                        !isSortOpenAndMobile() && !isFilterOpenAndMobile() && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterIcon/* MobileFilterIcon */.H, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "filterText",
                            children: "".concat(isSortOpenAndMobile() || isFilterOpenAndMobile() ? "Close" : "Filters")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "spacing-flex"
                }),
                !checkClientDeviceType/* IS_MOBILE */.q$ ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByCtaDesktop, {
                    selectedSortingText: selectedSortingText,
                    toggleShowDropDown: toggleShowDropDown,
                    setShowDropDown: setShowDropDown,
                    showDropDown: showDropDown,
                    handleSortType: handleSortType
                }) : !props.showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByCtaMobile, {
                    selectedSortingText: selectedSortingText,
                    toggleShowDropDown: toggleShowDropDown,
                    showDropDown: showDropDown,
                    handleSortType: handleSortType,
                    isFilterOpenAndMobile: isFilterOpenAndMobile,
                    isSortOpenAndMobile: isSortOpenAndMobile
                })
            ]
        })
    });
}
/* harmony default export */ var SortingAndFiltersTab_SortingAndFiltersTab = (SortingAndFiltersTab);


/***/ }),

/***/ 179220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GlobalCfeLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _globalLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(325480);


var GlobalCfeLoader = function(param) {
    var type = param.type, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_globalLoader__WEBPACK_IMPORTED_MODULE_1__/* .GlobalLoader */ .k, {
        type: type,
        color: color
    });
};


/***/ }),

/***/ 325480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GlobalLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(185134);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(798388);
/* harmony import */ var src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(326706);
/* harmony import */ var src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965700);







var GlobalLoader = function(props) {
    var type = props.type, color = props.color;
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.style.setProperty("--loader-color", color);
    }, [
        color
    ]);
    switch(type){
        case "logo1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo1)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "logo2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo2)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "loader1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    version: "1.1",
                    id: "L9",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "65px",
                    height: "65px",
                    viewBox: "0 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: color,
                        d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            dur: "1s",
                            from: "0 50 50",
                            to: "360 50 50",
                            repeatCount: "indefinite"
                        })
                    })
                });
            }
        case "loader2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L5",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 15 ; 0 -15; 0 15",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "30",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 10 ; 0 -10; 0 10",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "54",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader3":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader3), "tw-h-[35px] tw-w-[35px]")
                });
            }
        case "loader4":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L4",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "26",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "46",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader5":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader5), "tw-h-[16px] tw-w-[35px]")
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
            }
    }
};


/***/ }),

/***/ 810445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PROMO_APPLICABILITY_TYPES; }
/* harmony export */ });
/* unused harmony export PROMO_TYPES */
var PROMO_TYPES = {
    GENERAL: 1,
    PRODUCT: 2,
    TAG: 3,
    CATEGORY: 4,
    COLLECTION: 5,
    BUYXGETY: 6
};
var PROMO_APPLICABILITY_TYPES = {
    PRODUCT: 1,
    TAG: 2,
    CATEGORY: 3,
    COLLECTION: 4
};


/***/ }),

/***/ 130553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useGetTypeIdFromCanonicalDataStore; }
/* harmony export */ });
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(268037);
/* harmony import */ var src_utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);


var useGetTypeIdFromCanonicalDataStore = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var ref;
    var canonicalData = (0,src_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.catalogReducer.canonicalData;
    });
    return {
        typeId: +id || +(canonicalData === null || canonicalData === void 0 ? void 0 : (ref = canonicalData.item_group_details) === null || ref === void 0 ? void 0 : ref.id),
        isTypeCollection: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.COLLECTION */ .Rv.COLLECTION,
        isTypeCategory: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.CATEGORY */ .Rv.CATEGORY,
        isTypeTags: (canonicalData === null || canonicalData === void 0 ? void 0 : canonicalData.type) === src_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_TYPE_ID.TAG */ .Rv.TAG
    };
};


/***/ }),

/***/ 302876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);




/**
 *
 * @param {*} ref reference to the div element whose height is checked from top
 * @param {*} generalConditon a set of condition that can overwrite the logic if true
 * @param {*} offsetTopHeight when element height distance is less than this value setstate triggers
 * @param {*} offsetBottomHeight when element height distance is less than this value setstate triggers
 * @returns {boolean} is element height is under offsetTopHeight or not
 */ function useTriggerChangeTopHeightMobile(ref, generalConditon, offsetTopHeight, offsetBottomHeight) {
    var checkifScrolledOffset = function checkifScrolledOffset() {
        var _$ref, _$ref1;
        if (((_$ref1 = (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.getBoundingClientRect()) === null || _$ref1 === void 0 ? void 0 : _$ref1.top) <= offsetTopHeight) {
            var _$ref2, _$ref3;
            if (((_$ref3 = (_$ref2 = ref.current) === null || _$ref2 === void 0 ? void 0 : _$ref2.getBoundingClientRect()) === null || _$ref3 === void 0 ? void 0 : _$ref3.bottom) <= offsetBottomHeight) {
                setIsElementUnderOffset(false);
            } else setIsElementUnderOffset(true);
        } else setIsElementUnderOffset(false);
    };
    if (generalConditon) generalConditon;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isElementUnderOffset = ref1[0], setIsElementUnderOffset = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .MAX_MOBILE_WIDTH */ .Cf) window.addEventListener("scroll", checkifScrolledOffset);
        checkifScrolledOffset();
        return function() {
            window.removeEventListener("scroll", checkifScrolledOffset);
        };
    }, []);
    return isElementUnderOffset;
}
/* harmony default export */ __webpack_exports__["Z"] = (useTriggerChangeTopHeightMobile);


/***/ }),

/***/ 542249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(225617);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96031);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(268037);




function useTriggerInitialFilterOptions() {
    var additionalCondition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var callInitialGetFilteredItemsOptions = function callInitialGetFilteredItemsOptions() {
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: []
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .getFilteredItemsOptions */ .OI)(payload));
    };
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var storeData = (0,_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return {
            sortType: state.catalogReducer.sortType,
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter
        };
    }), sortType = ref.sortType, filterAppliedCounter = ref.filterAppliedCounter;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!filterAppliedCounter && (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && additionalCondition) {
            callInitialGetFilteredItemsOptions();
        }
    }, [
        filterAppliedCounter,
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        additionalCondition
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTriggerInitialFilterOptions);


/***/ }),

/***/ 146788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useProductListParentForBuilderHOC; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(474151);





// Takes in StyledComponent & passes a custom flag in it for builder
var useProductListParentForBuilderHOC = function(Component) {
    var ref = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_2__/* .useWidgetDndContextData */ .KX)(), _widgetContextState = ref.widgetContextState, isBuilder = _widgetContextState.isBuilder, previewDevice = _widgetContextState.previewDevice;
    var isBuilderMobile = isBuilder && previewDevice === "mobile";
    var HOC = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
            isBuilderMobile: isBuilderMobile
        }));
    }, [
        isBuilderMobile
    ]);
    return HOC;
};


/***/ }),

/***/ 156385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ conditionalForMiddlebodyRender; }
/* harmony export */ });
/**
 * Utility condition to check
 * for conditional render
 * to fix for layout inconsistencies
 * @param {number} isHeroBannerHeightCalculated
 * @param {boolan} isThemeId
 * @param {boolean} isShopRoute
 * @return {boolean}
 */ var conditionalForMiddlebodyRender = function(isHeroBannerHeightCalculated) {
    var isThemeId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, isShopRoute = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return isHeroBannerHeightCalculated || isThemeId || isShopRoute;
};


/***/ }),

/***/ 936051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ getFilteredOptionsProducts; }
/* harmony export */ });
/* harmony import */ var _components_DesignSystem_MiddleBody_MiddleBody7_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(708710);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96031);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17247);



var getFilteredOptionsProducts = function(filterOptions) {
    var pageNo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, extraField = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        isMiddleBody7: false
    };
    var ref;
    var storeId = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().storeReducer.store.store_id;
    var sorting_type = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().catalogReducer) === null || ref === void 0 ? void 0 : ref.sortType;
    var dispatch = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dispatch */ .Z.dispatch;
    if (extraField === null || extraField === void 0 ? void 0 : extraField.isMiddleBody7) {
        var ref1;
        var isNextPage = (ref1 = (0,_components_DesignSystem_MiddleBody_MiddleBody7_utils__WEBPACK_IMPORTED_MODULE_0__/* .getStoredMB7SortAndFilterConfig */ .Tr)()) === null || ref1 === void 0 ? void 0 : ref1.isNextPage;
        if (!isNextPage) {
            return {
                status: false,
                is_next_page: false
            };
        }
    }
    return new Promise(function(resolve, reject) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .getFilteredItemsOptions */ .OI)({
            store_id: storeId,
            page_no: pageNo,
            sorting_type: sorting_type,
            filters: filterOptions
        }, function(status, is_next_page) {
            return status ? resolve({
                status: status,
                is_next_page: is_next_page
            }) : reject(status);
        }));
    });
};


/***/ }),

/***/ 295218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ removeDsAdsRouteLink; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);

function removeDsAdsRouteLink() {
    window.open(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT_DS_ADS_LINK.COMMON_REDIRECTION_LINK */ .gr.COMMON_REDIRECTION_LINK, "_blank");
}


/***/ }),

/***/ 287243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ scrollOnPageLoad; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/**
 * Checks whether sessionStorage has an item clicked data stored.
 * Then verifies whether the duration between clicked time and returning
 * back to home screen is > 30seconds. Then returns whether session storage
 * contains x and y coordinates of clicked item from PDP section.
 * If the session has those, then return the coordinates else return false.
 * This function is currently being used by Home component on page load.
 */ 
function scrollOnPageLoad() {
    var currTime = new Date();
    var sessionObject = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI));
    if (sessionObject) {
        var expirationTime = sessionObject === null || sessionObject === void 0 ? void 0 : sessionObject.expiresAt;
        if (expirationTime && Date.parse(currTime) < Date.parse(expirationTime)) {
            var ref, ref1;
            var y_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref = sessionObject.itemClickedData) === null || ref === void 0 ? void 0 : ref.CLICKED_ITEM_Y_OFFSET;
            var x_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref1 = sessionObject.itemClickedData) === null || ref1 === void 0 ? void 0 : ref1.CLICKED_ITEM_X_OFFSET;
            if (y_offset && y_offset !== 0) {
                return {
                    toScroll: true,
                    x_scroll: x_offset,
                    y_scroll: y_offset
                };
            }
        } else {
            sessionStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI);
        }
    }
    return {
        toScroll: false
    };
}


/***/ }),

/***/ 305305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(629815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);


function useIsClickOutside(ref) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    for(var _len = arguments.length, callbackArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        callbackArgs[_key - 2] = arguments[_key];
    }
    var handleClickOutside = function handleClickOutside(e) {
        var _$ref;
        if (!((_$ref = e.composedPath()) === null || _$ref === void 0 ? void 0 : _$ref.includes(ref.current))) {
            e.stopPropagation();
            callback && callback.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(callbackArgs));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsClickOutside);


/***/ }),

/***/ 185134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo1":"globalLoader_logo1__U4pxQ","logo-1":"globalLoader_logo-1__07zYZ","logo2":"globalLoader_logo2__eivVl","loader-3":"globalLoader_loader-3__8hklP","loader3":"globalLoader_loader3__m47Bj","loader5":"globalLoader_loader5__6NXRf","loader-5-1":"globalLoader_loader-5-1__pESNT","loader-5-2":"globalLoader_loader-5-2__VgxuZ"};

/***/ })

}]);